import { Text } from '@/components/ui/text';
import { useAppearance } from '@/lib/design/appearance';
import { getDesignTokens } from '@/lib/design/theme';
import * as React from 'react';
import { StyleSheet } from 'react-native';

export function PublicWebPanelTitle({ children }: { children: React.ReactNode }) {
  const resolvedMode = useAppearance((state) => state.resolvedMode);
  const tokens = React.useMemo(() => getDesignTokens(resolvedMode), [resolvedMode]);
  const styles = React.useMemo(() => createStyles(tokens), [tokens]);

  return <Text style={styles.title}>{children}</Text>;
}

function createStyles(tokens: ReturnType<typeof getDesignTokens>) {
  return StyleSheet.create({
    title: {
      color: tokens.colors.text,
      fontFamily: tokens.typography.fonts.displayBold,
      fontSize: 24,
      letterSpacing: -0.8,
      lineHeight: 28,
    },
  });
}
